/**
 * Enable form validation
 * 
 * @export
 * @class Validation
 */
export class Validation {

    constructor() {
        document.addEventListener('invalid', (event) => {
            const field = event.target;

            if (!this.isFormField(field)) {
                return;
            }

            if (field.validity.valueMissing) {
                field.setCustomValidity('Required');
            }
        }, true);

        document.addEventListener('input', (event) => this.clearCustomValidity(event));
        document.addEventListener('change', (event) => this.clearCustomValidity(event));
    }

    private clearCustomValidity(event: Event): void {
        const field = event.target;

        if (this.isFormField(field)) {
            field.setCustomValidity('');
        }
    }

    private isFormField(field: EventTarget | null): field is HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement {
        return field instanceof HTMLInputElement ||
            field instanceof HTMLTextAreaElement ||
            field instanceof HTMLSelectElement;
    }
}
